/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The selectors for the widget Search Accounts
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../../reducers/rootReducer';
import { IWidgetSearchAccountsItem } from './types/widgetSearchAccountsTypes';
import { IWidgetSearchAccountsReducer } from './widgetSearchAccountsReducer';


export const makeSelectWidgetSearchAccounts = (state: IRootReducer): IWidgetSearchAccountsReducer =>
    state.dashboard.widgetSearchAccounts;

/*
* -------------------------------------------
*           SEARCH VALUE
* -------------------------------------------
*/

export const makeSelectWidgetSearchAccountsSearchValue = ():
    OutputSelector<IRootReducer, string, (state: IWidgetSearchAccountsReducer) => string> =>
    createSelector(makeSelectWidgetSearchAccounts,
        (state) => state.searchValue.trim());

/*
* -------------------------------------------
*           SELECTED ACCOUNT
* -------------------------------------------
*/

export const makeSelectWidgetSearchAccountsSelectedAccount = ():
    OutputSelector<IRootReducer, IWidgetSearchAccountsItem, (state: IWidgetSearchAccountsReducer) =>
        IWidgetSearchAccountsItem> => createSelector(makeSelectWidgetSearchAccounts,
        (state) => state.selectedAccount);

/*
* -------------------------------------------
*           HAS MORE
* -------------------------------------------
*/

export const makeSelectWidgetSearchAccountsHasMore = ():
    OutputSelector<IRootReducer, boolean, (state: IWidgetSearchAccountsReducer) =>
        boolean> => createSelector(makeSelectWidgetSearchAccounts,
    (state) => state.hasMore);


/*
* -------------------------------------------
*           ACCOUNT LIST
* -------------------------------------------
*/

export const makeSelectWidgetSearchAccountsList = ():
    OutputSelector<IRootReducer, IWidgetSearchAccountsItem[], (state: IWidgetSearchAccountsReducer) =>
        IWidgetSearchAccountsItem[]> => createSelector(makeSelectWidgetSearchAccounts,
    (state) => state.accountList);


/*
* -------------------------------------------
*           IS LOADING
* -------------------------------------------
*/

export const makeSelectWidgetSearchAccountsIsLoading = ():
    OutputSelector<IRootReducer, boolean, (state: IWidgetSearchAccountsReducer) => boolean> =>
    createSelector(makeSelectWidgetSearchAccounts,
        (state) => state.isLoading);

/*
* -------------------------------------------
*           ERROR MESSAGE
* -------------------------------------------
*/

export const makeSelectWidgetSearchAccountsError = ():
    OutputSelector<IRootReducer, string, (state: IWidgetSearchAccountsReducer) => string> =>
    createSelector(makeSelectWidgetSearchAccounts,
        (state) => state.message);
